import React, { useMemo } from "react";
import { useTaxonomyContext } from "../../../contexts/Taxonomy/TaxonomyContext";
import { HgNaics } from "../../../types/taxonomy";
import TreeSelect from "../TreeSelect/TreeSelect";
import { transformToTree } from "../TreeSelect/utils";
import { INDUSTRY_MESSAGES } from "./constants";

interface NaicsInputProps {
  onNaicsSelect: (naicsIds: string[]) => void;
  selectedItems: string[];
  id?: string;
}

export const NaicsInput: React.FC<NaicsInputProps> = ({
  onNaicsSelect,
  selectedItems = [],
  id = "naics-input",
}) => {
  const { naics } = useTaxonomyContext();

  const allOptions = useMemo(
    () => transformToTree(naics as HgNaics[], (i) => `${i.code}: ${i.name}`),
    [naics]
  );

  return (
    <TreeSelect
      id={id}
      items={allOptions}
      selectedItems={selectedItems}
      onSelectItems={onNaicsSelect}
      placeholder={INDUSTRY_MESSAGES.PLACEHOLDER}
      noOptionsMessage={INDUSTRY_MESSAGES.NO_RESULTS}
    />
  );
};
